export default "__VITE_ASSET__DJIb39Fm__"